<template>
    <div class="g row">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .g.row {
        display: flow-root;

        > .g.cell {
            box-sizing: border-box;
            padding: $interval-xs;
            margin-top: 0 !important;

            @for $i from 2 through 20 {
            
                &:nth-of-type(1):nth-last-of-type(#{$i}) {
                    float: left;
                    width: ( 100% / $i );
                }
                
                &:nth-of-type(1):nth-last-of-type(#{$i}) ~ .g.cell {
                    float: left;
                    width: ( 100% / $i );
                }
            }
        }
    }
</style>
